import Vue from 'vue'
import Router from 'vue-router'
import HotelList from '@/views/hotel_list/HotelList'
import i18n from '@/lang';

const HotelDetail = resolve => require(['@/views/hotel_detail/HotelDetail.vue'], resolve);
const HotelBooking = resolve => require(['@/views/hotel_booking/HotelBooking.vue'], resolve);
const Payment = resolve => require(['@/views/payment/Payment.vue'], resolve);
const PaymentSuccess = resolve => require(['@/views/payment/Success.vue'], resolve);
const EvaluationPublish = resolve => require(['@/views/evaluation/EvaluationPublish.vue'], resolve);

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/hotel',
  routes: [
    {
      path: '/',
      redirect: '/list'
    },
    {
      path: '/list',
      name: 'HotelList',
      component: HotelList,
      meta: {
        title: i18n.t('TITLE.default'), // 酒店预订
        keepAlive: true
      }
    },
    {
      path: '/detail/:hotel_id/:start_date?/:end_date?',
      name: 'HotelDetail',
      component: HotelDetail,
      props: true,
    },
    {
      path: '/booking',
      name: 'HotelBooking',
      component: HotelBooking,
      meta: {
        title: i18n.t('hotel.Book_Hotel'),  // 酒店预订
      }
    },
    {
      path: '/order/payment/:order_id',
      name: 'Payment',
      props: true,
      component: Payment,
      meta: {
        title: i18n.t('hotel.Book_Hotel'),  // 酒店预订
      }
    },
    {
      path: '/order/payment/success/:order_id',
      name: 'PaymentSuccess',
      props: true,
      component: PaymentSuccess,
      meta: {
        title: i18n.t('hotel.PAY_SUCCESS'), // 支付成功
      }
    },
    {
      path: '/evaluation/publish/:hotel_id',
      name: 'EvaluationPublish',
      component: EvaluationPublish,
      props: true,
      meta: {
        title: '酒店评价',
      }
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js